import { lockScreenScroll } from '../utils/treatment';
import { hideFixedForm } from './actionsForm';

const sidebarFixed = document.querySelector('.sidebar-fixed');
const formMain = document.querySelector('.form-main');
const closeSidebar = document.querySelector('.btn-close-sidebar');

// FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
export function sidebarFixedBehavior(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((target) => {

    target.addEventListener('click', () => {

      if(formMain && formMain.classList.contains('form-content-fixed')) {
        hideFixedForm();
        lockScreenScroll();
      }

      sidebarFixed.classList.toggle('d-flex');

    });
  });
}

// BUTTON TO SIDEBAR
closeSidebar.addEventListener('click', () => {
  sidebarFixed.classList.toggle('d-flex');

});

